import common from 'store/modules/seller/common';
import sellerUser from 'store/modules/seller/sellerUser';
import sellerCommon from 'store/modules/seller/sellerCommon';
import sellerShops from 'store/modules/seller/sellerShops';
import sellerCampaigns from 'store/modules/seller/sellerCampaigns';
import sellerAutostrategy from 'store/modules/seller/sellerAutostrategy';
import notifications from 'store/modules/notifications/notifications';
import bidderPerformanceSeller from 'store/modules/seller/sellerBidderPerformance';


export const modules = {
  common,
  sellerUser,
  sellerCommon,
  sellerShops,
  sellerCampaigns,
  sellerAutostrategy,
  notifications,
  bidderPerformanceSeller
};
